import React, { useEffect, useState } from 'react';
import { Link, useLocation, useSearchParams, useNavigate  } from 'react-router-dom';

import { get } from '../../utils/api'

import { isMobile, SERVER_URL } from '../../config';
import { updateHeaderColor, updateMobileHeaderColor } from '../../utils/scroll';
import HeaderComponents from '../../components/Header/HeaderComponents';
import ProdSdBnComp from '../../components/SideBanner/ProdSdBnComp';
import { fetchProductDetailData } from '../../services/productService';
import ProdModal from '../../components/Modal/ProdModal';
import Pagination from '../../components/Paging/Pagination';

import style from './ProdListPage.module.css';

const ProdListPage = () => {

  const [ srchList, setSrchList ] = useState([]);
  const [ chkDiv, setChkDiv ] = useState([]);
  const [ chkOp, setChkOp ] = useState([]);
  const [ chkDesc, setChkDesc ] = useState([]);
  const [ isDetailModalOpen, setIsDetailModalOpen ] = useState(false);
  const [ prdFileData, setPrdFileData ] = useState([]);

  const [ prdSrchList, setPrdSrchList ] = useState([]);
  const [ pagingSrchInfo, setPagingSrchInfo ] = useState([]);

  const [ prdList, setPrdList ] = useState([]);
  const [ pagingInfo, setPagingInfo ] = useState([]);
  
  const [ curPage, setCurPage ] = useState(1);

  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  
  const idx = parseInt(searchParams.get("list"));
  const itemIdx = parseInt(searchParams.get("item"));

  useEffect(() => {
    window.scrollTo(0, 327);
  }, [location]);
  
  useEffect(() => {
    const wheelHandler = (e) => {
      if(isMobile()) {
        updateMobileHeaderColor();
      } else {
        updateHeaderColor();
      }
    };

    window.addEventListener('scroll', wheelHandler);

    return () => {
      window.removeEventListener('scroll', wheelHandler);
    };
  }, []);

  useEffect(() => {
    const pageIdx = parseInt(searchParams.get('pageIdx')) || 1;
    setCurPage(pageIdx);
    prdSrchListData(pageIdx);
    prdListData(pageIdx);
  }, [location, curPage]);

  useEffect(() => {
    const fetchData = async () => {
      if (itemIdx) {
        const fileResponse = await get(`/product/file?idx=${itemIdx}`);
        const fileExists = fileResponse.length > 0;
  
        const productDetailData = await fetchProductDetailData(itemIdx, idx);
        setPrdFileData(productDetailData);

        const fromBackButton = location.state?.fromBackButton;
  
        if (fileExists && fileResponse[0].FILE_TYPE === "C" && !fromBackButton) {
          navigate(`/product/detail?idx=${itemIdx}&list=${idx}`, { replace: true });
        } else {
          setIsDetailModalOpen(true);
        }
      }
    };
  
    fetchData();
  }, [itemIdx]);


  const searchListData = async () => {
    try {
      const divListRs = await get(`/product/divlist`)
      const opListRs = await get(`/product/oplist`)
      const descListRs = await get(`/product/desclist`)

      const combinedList = {
        divList: divListRs || [],
        opList: opListRs || [],
        descList: descListRs || []
      };
  
      const srchListArray = Object.values(combinedList);
      setSrchList(srchListArray);

    } catch (err) {
        console.log(err);
    };
  };

  const prdSrchListData = async () => {
    try {
      const chkDivStr = encodeURIComponent(JSON.stringify(chkDiv));
      const chkOpStr = encodeURIComponent(JSON.stringify(chkOp));
      const chkDescStr = encodeURIComponent(JSON.stringify(chkDesc));
      
      const response = await get(`/product/srchlist?chkDiv=${chkDivStr}&chkOp=${chkOpStr}&chkDesc=${chkDescStr}`, {
        pageIdx: curPage
      });

      setPrdSrchList(response.prdSrchList);
      setPagingSrchInfo(response.pageInfo);
  
    } catch (err) {
      console.log(err);
    }
  };

  const prdListData = async () => {
    try {
        const response = await get(`/product/list?idx=${idx}`, {
          pageIdx: curPage
        });
        setPrdList(response.prdList);
        setPagingInfo(response.pageInfo);
    } catch (err) {
        console.log(err);
    };
  };

  useEffect(() => {
    searchListData();
    prdListData();
  }, [location, curPage]);

  const handleCheckboxChange = async (type, value, checked) => {
    setCurPage(1);
    navigate(`/product/list?list=${idx}&pageIdx=1`);
    switch (type) {
      case 'DIV':
        setChkDiv(prevChkDiv => checked ? [...prevChkDiv, value] : prevChkDiv.filter(item => item !== value));
        break;
      case 'OP':
        setChkOp(prevChkOp => checked ? [...prevChkOp, value] : prevChkOp.filter(item => item !== value));
        break;
      case 'DESC':
        setChkDesc(prevChkDesc => checked ? [...prevChkDesc, value] : prevChkDesc.filter(item => item !== value));
        break;
      default:
        break;
    }
  
  };

  useEffect(() => {
    const fetchData = async () => {
      await prdSrchListData();

      renderSrch();
    };
  
    fetchData();
  }, [chkDiv, chkOp, chkDesc, curPage]); 


  const onPageChangeHandler = (pageNumber) => {
    setCurPage(pageNumber); 
    navigate(`/product/list?list=${idx}&pageIdx=${pageNumber}`);
  };

  const showSrchList = () => {
    return (
      <>
        <div className='flex-row'>
          <label className={style.srchName}>제품 구분 </label>
          <div className={style.srchContDiv}>
            {srchList[0] && srchList[0].map(item => (
              <label key={item.DIV_2_SEQ} className={style.srchCont}>
                <input 
                  type="checkbox" 
                  value={item.DIV_2_SEQ} 
                  onChange={e => handleCheckboxChange('DIV', item.DIV_2_SEQ, e.target.checked)}
                  className={style.srchInput} 
                />
                <a>{item.DIV_2_NAME}</a>
              </label>
            ))}
          </div>
        </div>
  
        <div className='flex-row'>
          <label className={style.srchName}>주파수 및 프로토콜 </label>
          <div className={style.srchContDiv}>
            {srchList[1] && srchList[1].map(item => (
              <label key={item.OPTION_SEQ} className={style.srchCont}>
                <input 
                  type="checkbox" 
                  value={item.OPTION_SEQ} 
                  onChange={e => handleCheckboxChange('OP', item.OPTION_SEQ, e.target.checked)} 
                  className={style.srchInput} 
                />
                <a>{item.OPTION_NAME}</a>
              </label>
            ))}
          </div>
        </div>

        <div className='flex-row'>
          <label className={style.srchName}>인터페이스 </label>
          <div className={style.srchContDiv}>
            {srchList[2] && srchList[2].map(item => (
              <label key={item.DESC_SEQ} className={style.srchCont}>
                <input 
                  type="checkbox" 
                  value={item.DESC_SEQ} 
                  onChange={e => handleCheckboxChange('DESC', item.DESC_SEQ, e.target.checked)} 
                  className={style.srchInput} 
                />
                <a>{item.DESC_NAME}</a>
              </label>
            ))}
          </div>
        </div>
      </>
    );
  };
  
  const showPrdSrchList = (pdsSeq, pdsName, pdsDes, pdsImg, index) => {
    const isScndPrd = index % 3 === 1;
    const prodDivCss = `flex-column ${style.prodDiv} ${isScndPrd ? style.scndPrdDiv : ''}`;

    return (
      <Link key={index} className={prodDivCss} to={`/product/detail?idx=${pdsSeq}&list=${idx}`}>
        <img src={SERVER_URL + pdsImg} alt='List_Img' className={style.pdsImg}></img>
        <div className={`fw-300 ${style.prdSbj}`}>{pdsDes}</div>
        <div className={`fw-700 ${style.prdDscrp}`}>{pdsName}</div>
      </Link>
    );
  };

  const renderSrch = () => {
    const rows = [];
    const itemsPerRow = isMobile() ? 2 : 3;

    for (let i = 0; i < prdSrchList.length; i += itemsPerRow) {
      const rowItems = prdSrchList.slice(i, i + itemsPerRow);
      const row = (
        <div key={i / itemsPerRow} className={style.lineDiv}>
          {rowItems.map((pds, index) => showPrdSrchList(pds.INFO_SEQ, pds.INFO_NAME, pds.INFO_DESCRIPTION, pds.INFO_IMG_PATH, index))}
        </div>
      );
      rows.push(row);
    }
    return rows;
  };

  const closeDetailModal = () => {
    setIsDetailModalOpen(false);
    setPrdFileData(null);
  };

  const showPrdList = (prdSeq, prdName, prdDes, prdImg, index) => {
    const isScndPrd = index % 3 === 1;
    const prodDivCss = `flex-column ${style.prodDiv} ${isScndPrd ? style.scndPrdDiv : ''}`;
  
    const handleItemClick = async () => {
      const fileResponse = await get(`/product/file?idx=${prdSeq}`);
      const fileExists = fileResponse.length > 0;

      const productDetailData = await fetchProductDetailData(prdSeq, idx);
      setPrdFileData(productDetailData);
      setIsDetailModalOpen(true);
      
      if (fileExists && fileResponse[0].FILE_TYPE === "C") {
        navigate(`/product/detail?idx=${prdSeq}&list=${idx}`);
      } else {
        setIsDetailModalOpen(true);
      }
    };
    
    return (
      <div key={index} className={prodDivCss} onClick={handleItemClick}>
        <img src={SERVER_URL + prdImg} alt='List_Img' className={style.pdsImg}></img>
        <div className={style.prdSbj}>{prdDes}</div>
        <div className={style.prdDscrp}>{prdName}</div>
      </div>
    );
  };

  const renderRows = () => {
    const rows = [];
    const itemsPerRow = isMobile() ? 2 : 3;
  
    for (let i = 0; i < prdList.length; i += itemsPerRow) {
      const rowItems = prdList.slice(i, i + itemsPerRow);
      const row = (
        <div key={i / itemsPerRow} className={style.lineDiv}>
          {rowItems.map((prd, index) => 
            showPrdList(prd.INFO_SEQ, prd.INFO_NAME, prd.INFO_DESCRIPTION, prd.INFO_IMG_PATH, index)
          )}
        </div>
      );
      rows.push(row);
    }
  
    return rows;
  };

  return (
    <>
        <HeaderComponents pageKey="product" />
        <div className="inner-container">
          <ProdSdBnComp location={location} />

          <div className="prod-list-div" style={{minHeight:'650px'}}>
            <>
              <div>
                {idx === 1 ? (
                  <>
                    <div className={style.srchDiv}>
                      {showSrchList(srchList)}
                    </div>
                    <div className="srch-prod-line"></div>

                    <div className={`flex-column ${style.listDiv}`}>
                      {prdSrchList.length === 0 ? (
                        <div className={`mt-150 mb-50 ${style.noneTitle}`}>
                          제품 <span className='rf-font'>준비중</span> 입니다.
                        </div>
                      ) : (
                        renderSrch()
                      )}
                    </div>

                    <Pagination
                      currentPage={pagingSrchInfo.curPage}
                      totalPages={pagingSrchInfo.totalPage}
                      onPageChangeHandler={onPageChangeHandler}
                    />
                  </>
                ): (
                    prdList.length === 0 ? (
                      <div className={`mt-150 mb-300 ${style.noneTitle}`}>
                        제품 <span className='rf-font'>준비중</span> 입니다.
                      </div>
                    ): (
                      <>
                        <div className="prod-line"></div>

                        <div className={`flex-column ${style.listDiv}`}>
                          {renderRows()}
                        </div>

                        <Pagination
                          currentPage={pagingInfo.curPage}
                          totalPages={pagingInfo.totalPage}
                          onPageChangeHandler={onPageChangeHandler}
                        />
                    </>
                    )
                )}
              </div>
            </>
          </div>
        </div>
        {isDetailModalOpen && (
          <ProdModal isOpen={isDetailModalOpen} onClose={closeDetailModal} data={prdFileData} imgUrl={SERVER_URL} curIdx={idx}/>
        )} 
    </>
  );
};

export default ProdListPage;
